import { FC } from 'react'
import { Container, Row, Col, Spinner, Dropdown } from '@mch-group/uikit-components'
import VirtualGrid from '@components/VirtualGrid'
import ArtworkItem from '@modules/Catalog/Artworks/ArtworkItem'
import ShowMore from '@components/ShowMore'
import type IArtworkCard from 'types/IArtworkCard'

interface IOptions {
  key: number
  label: string
  value: string
}

interface ICatalogueArtworksList {
  sortByLabel: string
  selectedValue: string
  options: Array<IOptions>
  handleChange: Function
  isItemsLoading: boolean
  total: number
  totalItemsLabel: string
  list: Array<IArtworkCard>
  groupBy: string
  sortBy: string
  direction: string
  isLoadingNewpage: boolean
  handleShowMore: Function
  hideShowMoreButton: boolean
  noItemsAvailableLabel: string
  artworkOwnerData: any
  labels: {
    [key: string]: string
  }
  isCatalogueArtwork: boolean,
  labelsList: {
    youHaveSeen: string,
    of: string,
    items: string
  }
}

const CatalogueArtworksList: FC<ICatalogueArtworksList> = ({
  sortByLabel,
  selectedValue,
  options,
  handleChange,
  isItemsLoading,
  artworkOwnerData,
  total,
  totalItemsLabel,
  list,
  groupBy,
  sortBy,
  direction,
  isLoadingNewpage,
  handleShowMore,
  hideShowMoreButton,
  noItemsAvailableLabel,
  labels,
  isCatalogueArtwork,
  labelsList
}) => {
  if (!list && !isItemsLoading) return null

  return (
    <div>
      <Container className='mt-10'>
        <Row className='mb-xl-9 mb-xxl-11'>
          <Col className='col-6 col-md-4 col-lg-3 col-xl-2 mt-0 mt-md-5 mt-xl-7'>
            <Dropdown
              className='mb-9 mb-md-10 mb-lg-0 mb-xl-0 mb-xxl-0'
              label={sortByLabel}
              value={selectedValue}
              // @ts-ignore
              options={options}
              // @ts-ignore
              onChange={(value) => {
                handleChange(value)
              }}
              onVisibilityChange={() => {}}
            />
          </Col>
          <Col className='col-2 col-md-4 col-lg-6 col-xl-8'>
            {isItemsLoading && (
              <div className='d-flex align-items-center justify-content-center'>
                <Spinner variant='button' theme='light' />
              </div>
            )}
          </Col>
          <Col className='col-4 col-md-3 col-lg-3 col-xl-2 align-self-end justify-content-end d-flex'>
            {total && totalItemsLabel ? `${total} ${totalItemsLabel}` : ''}
          </Col>
        </Row>
        {list?.length > 0 && (
          <Row>
            <Col>
              <VirtualGrid
                //@ts-ignore
                items={list}
                groupBy={groupBy}
                sortBy={sortBy}
                direction={direction}
                cols={{
                  mobile: 1,
                  tablet: 2,
                  computer: 2,
                  largeScreen: 4
                }}
                gap={{
                  mobile: 0,
                  tablet: 16,
                  computer: 24,
                  largeScreen: 24
                }}
                gridStyle={{ paddingBottom: '20px' }}
                renderItem={(item) => (
                  <ArtworkItem
                    imageType='contained'
                    pageType='catalogue'
                    isCatalogueArtwork={isCatalogueArtwork}
                    artworkOwnerData={artworkOwnerData}
                    labels={{
                      viewAtFairLabel: labels?.viewAtFairLabel,
                      onlineExclusiveLabel: labels?.onlineExclusiveLabel,
                      artworkSoldLabel: labels?.artworkSoldLabel,
                      reservedArtworkLabel: labels?.reservedArtworkLabel,
                      artworkSavedToCollectionLabel: labels?.artworkSavedToCollectionLabel,
                      artworkInquiryButtonLabel: labels?.artworkInquiryButtonLabel
                    }}
                    {...item}
                  />
                )}
              />
            </Col>
          </Row>
        )}
        {isLoadingNewpage && (
          <div className='d-flex align-items-center justify-content-center'>
            <Spinner variant='button' theme='light' />
          </div>
        )}
        {list?.length > 0 && (
          <ShowMore
            isFetching={false}
            numberOfViewedItems={list?.length}
            numberOfTotalItems={total}
            //@ts-ignore
            onClick={() => {
              handleShowMore()
            }}
            showProgressBar
            label1={labelsList?.youHaveSeen || 'You have seen'}
            label2={labelsList?.of || 'of'}
            label3={labelsList?.items || 'items'}
            hideButton={hideShowMoreButton}
          />
        )}
        {list?.length == 0 && !isItemsLoading && <div className='mb-10'>{noItemsAvailableLabel}</div>}
      </Container>
    </div>
  )
}

export default CatalogueArtworksList
